const salePriceRange = [
  1000000,
  1250000,
  1500000,
  1750000,
  2000000,
  2500000,
  3000000,
  4000000,
  5000000,
  6000000,
  8000000,
  10000000,
  15000000,
  20000000,
];

const rentPriceRange = [
  3000,
  4000,
  5000,
  6000,
  7000,
  8000,
  9000,
  10000,
  12000,
  15000,
  20000,
  30000,
  40000,
  50000,
]

const moneyFormatter = new Intl.NumberFormat('en-SG', {
  style: 'currency',
  currency: 'SGD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const PRICE_MIN = {

  id: "price_min",
  type: "dropdown",
  props: {
    optionConditional: (formValues) => {
      const listing_type = formValues.listing_type?.value;
      const priceRange = (listing_type === "For Rent") ? rentPriceRange : salePriceRange;
      return priceRange.map(item => {
        return { label: moneyFormatter.format(item), value: item };
      });
    },
    dropdownProps: {
      label: "Min $",
      buttonProps: {
        className: "price_min",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: salePriceRange.map(item => {
      return { label: moneyFormatter.format(item), value: item };
    })
  }

}

const PRICE_MAX = {

  id: "price_max",
  type: "dropdown",
  props: {
    optionConditional: (formValues) => {
      const listing_type = formValues.listing_type?.value;
      const priceRange = (listing_type === "For Rent") ? rentPriceRange : salePriceRange;
      return priceRange.map(item => {
        return { label: moneyFormatter.format(item), value: item };
      });
    },
    dropdownProps: {
      label: "Max $",
      buttonProps: {
        className: "price_max",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: salePriceRange.map(item => {
      return { label: moneyFormatter.format(item), value: item };
    })
  }

}

const COL_PRICE_MIN = {

  id: "col_price_min",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [PRICE_MIN]

}

const COL_PRICE_MAX = {

  id: "col_price_max",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [PRICE_MAX]

}

const COL_MODAL_PRICE_MIN = {

  id: "col_price_min",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [PRICE_MIN]

}

const COL_MODAL_PRICE_MAX = {

  id: "col_price_max",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [PRICE_MAX]

}

export { PRICE_MIN, PRICE_MAX, COL_PRICE_MIN, COL_PRICE_MAX, COL_MODAL_PRICE_MIN, COL_MODAL_PRICE_MAX };
